import React, { useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../context/AuthContext';
import { fetchUserAttributes } from 'aws-amplify/auth';
import gravatar from 'gravatar';
import './navbar.css';

const getRandomColor = () => {
  const letters = '0123456789ABC';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * letters.length);
    color += letters[randomIndex];
  }
  // Check if the generated color is valid, else return a default color
  return color.length === 7 ? color : '#000000'; // Default to black if color generation fails
};

const Navbar = () => {
  const { user, signOut } = useAuth();
  const [userAttribute, setUserAttribute] = useState(null);
  const [gravatarUrl, setGravatarUrl] = useState(null);
  const [showSignOut, setShowSignOut] = useState(false);

  useEffect(() => {
    const loadUserAttributes = async () => {
      // Only fetch attributes if user is fully authenticated
      if (!user || !user.isSignedIn) {
        setUserAttribute(null);
        setGravatarUrl(null);
        return;
      }

      try {
        const attributes = await fetchUserAttributes();
        setUserAttribute(attributes);
        const userEmail = attributes.email;
        if (userEmail) {
          const firstLetter = userEmail.trim().toUpperCase().charAt(0);
          const bgColor = getRandomColor();
          const url = `https://ui-avatars.com/api/?name=${firstLetter}&size=80&background=${bgColor.slice(
            1
          )}&color=ffffff`;
          setGravatarUrl(url);
        }
      } catch (error) {
        console.error('Error fetching user attributes:', error);
      }
    };
    loadUserAttributes();
  }, [user]);

  const handleEngageClick = e => {
    e.preventDefault();
    navigate('/?elVideo=true'); // Navigate to the same page with elVideo=true
  };

  return (
    <nav className="navbar">
      <div className="navbarContainer">
        <Link to="/" className="navbarBrand engage-logo">
          <img
            src="../../images/EngageLogoUpdated.png"
            alt="KPOINT Logo"
            className="kpointLogo"
          />
        </Link>
        <div className="navbarLinks navBarContent">
          <a
            href="/?elVideo=true"
            onClick={handleEngageClick}
            className="navLink whatIsEl"
          >
            <FontAwesomeIcon icon={faPlay} className="elPlayIcon" />
            Engage
          </a>
          <Link
            to="/interactivity/"
            activeClassName="active"
            className="navLink"
          >
            Interactivity
          </Link>
          <Link to="/case-study/" activeClassName="active" className="navLink">
            Case Studies
          </Link>
          <a
            href="https://kpoint.com/"
            className="contactus"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
          {user &&
            gravatarUrl && ( // Only render avatar if gravatarUrl is set
              <div>
                <img
                  src={gravatarUrl}
                  alt="User Avatar"
                  className="userAvatar"
                  onClick={() => setShowSignOut(!showSignOut)} // Toggle showSignOut state on click
                />
                {showSignOut && (
                  <div
                    className="signOutLink navLink contactus signOut"
                    onClick={() => {
                      signOut(); // Call the signOut function
                      setShowSignOut(false); // Hide the sign-out link when signing out
                    }}
                  >
                    Signout
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
